<template>
    <ScrollFlexContainer 
        :max-height-px="tableHeightPx"
        :scroll-visibility="scrollbarApperance.visible"
    >
        <Table>
            <template v-slot:header>
                <SpacingClassWrapper :padding-bottom="0">
                    <TableCell
                        v-for="(headerText, index) in tableHeaders"
                        :key="index"
                        :variant="tableCellVariants.header"
                        :text-align="tableHeadersAlign"
                        :class="tableScrollHeaderClasses"
                    >
                        <Typography 
                            :color="typographyColors.greyMedium"
                            :variant="typographyVariants.caption"
                            :size="tableHeadersSize"
                            :weight="typographyWeights.regular"
                        >
                            {{ headerText }}
                        </Typography>
                    </TableCell>
                </SpacingClassWrapper>
            </template>
            <slot />
        </Table>
    </ScrollFlexContainer>
</template>

<script>
// Components
import Table from '../../components/Table';
import TableCell from '../../components/TableCell';
import Typography from '../../components/Typography';

// Class Wrappers
import SpacingClassWrapper from '../../classWrappers/SpacingClassWrapper';

// Containers
import ScrollFlexContainer from '../flex/ScrollFlexContainer';

// Types 
import { typographyColors, typographyVariants, typographyWeights, typographySizes } from '../../types/Typography.types';
import { scrollbarApperance, scrollbarApperanceDefault } from '../../types/ScrollFlex.types.js';
import { tableCellVariants, tableCellAlign } from '../../types/TableCell.types';

// Mixins
import styles from '../../mixins/styles.js';

export default {
    name: 'TableScrollContainer',
    components: {
        Table,
        TableCell,
        Typography,
        SpacingClassWrapper,
        ScrollFlexContainer,
    },
    mixins: [styles],
    props: {
        tableHeightPx: {
            type: Number,
            default: 0
        },
        tableHeaders: {
            type: Array,
            default: () => []
        },
        tableHeadersAlign: {
            type: String,
            default: null
        },
        tableHeadersSize : {
            type: String,
            default: typographySizes.caption
        }
    },
    data: function() {
        return {
            typographyColors,
            typographyVariants,
            typographyWeights,
            typographySizes,
            scrollbarApperance,
            tableCellVariants,
            tableCellAlign
        };
    },
    computed: {
        tableScrollHeaderClasses: function() {
            return [
                this.cssClasses.pcc__tableScroll__header
            ];
        }
    }
}
</script>
